const BOX = [
  { k: "totale", label: "Totale richieste", cls: "text-slate-900" },
  { k: "nuovo", label: "Nuove", cls: "text-amber-600" },
  { k: "in_corso", label: "In corso", cls: "text-sky-600" },
  { k: "completato", label: "Completate", cls: "text-emerald-600" },
  { k: "emergenze_aperte", label: "Emergenze aperte", cls: "text-red-600" },
];

export const StatsBar = ({ stats }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3" data-testid="stats-bar">
    {BOX.map(({ k, label, cls }) => (
      <div key={k} className={`rounded-2xl bg-white border p-4 ${k === "emergenze_aperte" && stats?.[k] ? "border-red-300 bg-red-50" : "border-slate-200"}`}>
        <p className="text-xs font-bold uppercase tracking-wider text-slate-500">{label}</p>
        <p className={`mt-1 text-3xl font-extrabold ${cls}`} data-testid={`stat-${k.replace("_", "-")}`}>{stats ? stats[k] ?? 0 : "–"}</p>
      </div>
    ))}
  </div>
);
